<span [class]="size()"><ng-content /></span>
